import { render } from "./AppFooter.vue?vue&type=template&id=55826df5"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=55826df5&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__